import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { links, constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modal/ConfirmModal/ConfirmModal'

import messages from './messages'


export default class NeedSubscribeModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedSubscribe,
    title: messages.title,
  }

  handleSubscribe = () => {
    this.close()
    actions.models.router.push(links.subscribe)
  }

  onCancel = () => {
    const { data: { onCancel } } = this.props

    if (typeof onCancel === 'function') {
      onCancel()
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.confirmButton}
        cancelTitle={messages.cancelButton}
        onConfirm={this.handleSubscribe}
        onCancel={this.onCancel}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}
